import React from "react";
import "./mainadminpage.css";
import { Fade } from "react-awesome-reveal";
import dash from "../../../img/undraw_dashboard_re_3b76.svg";
import { Link } from "react-router-dom";
const Mainadminpage = ({ isAdmin, userData }) => {
  const colors = ["#0d6efd", "#a31a27", "#198754", "#008aa6"];
  return (
    <div className="container">
      <div className="mainadminpage">
        <Fade direction="right">
          <div className="infmy">
            <div className="infoo">
              <h2>لوحة التحكم</h2>
            </div>
            <hr />
            <div className="myf">
              <ul className="footer-links">
                {/* <h2>الملفات</h2>  */}
                {isAdmin ? (
                  <li>
                    <i className="fa-solid fa-chevron-left"></i>{" "}
                    <Link to="/admin/adminmanage" style={{ color: "#40485b" }}>
                      <span
                        style={{
                          color: colors[Math.floor(Math.random() * 5) + 1],
                        }}>
                        {" "}
                        إدارة الأدمن
                      </span>
                    </Link>
                    <hr />
                  </li>
                ) : null}
                {isAdmin ? (
                  <li>
                    <i className="fa-solid fa-chevron-left"></i>{" "}
                    <Link
                      style={{ color: "#40485b" }}
                      to="/admin/subscribepackage">
                      <span
                        style={{
                          color: colors[Math.floor(Math.random() * 5) + 1],
                        }}>
                        {" "}
                        إدارة الباقات
                      </span>
                    </Link>
                    <hr />
                  </li>
                ) : (
                  userData?.claims?.map((claim, idx) =>
                    claim.claimName === "إضافة باقة" &&
                    claim.isSelected === true ? (
                      <li>
                        <i className="fa-solid fa-chevron-left"></i>{" "}
                        <Link
                          style={{ color: "#40485b" }}
                          to="/editor/subscribepackage">
                          <span
                            style={{
                              color: colors[Math.floor(Math.random() * 5) + 1],
                            }}>
                            {" "}
                            إدارة الباقات
                          </span>
                        </Link>
                        <hr />
                      </li>
                    ) : null
                  )
                )}
                {isAdmin ? (
                  <li>
                    <i className="fa-solid fa-chevron-left"></i>{" "}
                    <Link
                      style={{ color: "#40485b" }}
                      to="/admin/usermanagement">
                      <span
                        style={{
                          color: colors[Math.floor(Math.random() * 5) + 1],
                        }}>
                        {" "}
                        إدارة بيانات المستخدمين
                      </span>
                    </Link>
                    <hr />
                  </li>
                ) : (
                  userData?.claims?.map((claim, idx) =>
                    claim.claimName === "بيانات المستخدمين" &&
                    claim.isSelected === true ? (
                      <li>
                        <i className="fa-solid fa-chevron-left"></i>{" "}
                        <Link
                          style={{ color: "#40485b" }}
                          to="/editor/usermanagement">
                          <span
                            style={{
                              color: colors[Math.floor(Math.random() * 5) + 1],
                            }}>
                            {" "}
                            إدارة بيانات المستخدمين
                          </span>
                        </Link>
                        <hr />
                      </li>
                    ) : null
                  )
                )}
                {isAdmin ? (
                  <li>
                    <i className="fa-solid fa-chevron-left"></i>{" "}
                    <Link
                      style={{ color: "#40485b" }}
                      to="/admin/usersubscribe">
                      <span
                        style={{
                          color: colors[Math.floor(Math.random() * 5) + 1],
                        }}>
                        {" "}
                        إدارة بيانات المشتركين
                      </span>
                    </Link>
                    <hr />
                  </li>
                ) : (
                  userData?.claims?.map((claim, idx) =>
                    claim.claimName === "بيانات المشتركين" &&
                    claim.isSelected === true ? (
                      <li>
                        <i className="fa-solid fa-chevron-left"></i>{" "}
                        <Link
                          style={{ color: "#40485b" }}
                          to="/editor/usersubscribe">
                          <span
                            style={{
                              color: colors[Math.floor(Math.random() * 5) + 1],
                            }}>
                            {" "}
                            إدارة بيانات المشتركين
                          </span>
                        </Link>
                        <hr />
                      </li>
                    ) : null
                  )
                )}
                {isAdmin ? (
                  <li>
                    <i className="fa-solid fa-chevron-left"></i>{" "}
                    <Link style={{ color: "#40485b" }} to="/admin/emails">
                      <span
                        style={{
                          color: colors[Math.floor(Math.random() * 5) + 1],
                        }}>
                        {" "}
                        الإميلات
                      </span>
                    </Link>
                    <hr />
                  </li>
                ) : (
                  userData?.claims?.map((claim, idx) =>
                    claim.claimName === "الايميلات" &&
                    claim.isSelected === true ? (
                      <li>
                        <i className="fa-solid fa-chevron-left"></i>{" "}
                        <Link style={{ color: "#40485b" }} to="/editor/emails">
                          <span
                            style={{
                              color: colors[Math.floor(Math.random() * 5) + 1],
                            }}>
                            {" "}
                            الإميلات
                          </span>
                        </Link>
                        <hr />
                      </li>
                    ) : null
                  )
                )}
                {isAdmin ? (
                  <li>
                    <i className="fa-solid fa-chevron-left"></i>{" "}
                    <Link
                      style={{ color: "#40485b" }}
                      to="/admin/notifications">
                      <span
                        style={{
                          color: colors[Math.floor(Math.random() * 5) + 1],
                        }}>
                        {" "}
                        إدارة الأشعارات
                      </span>
                    </Link>
                    <hr />
                  </li>
                ) : (
                  userData?.claims?.map((claim, idx) =>
                    claim.claimName === "الاشعارات" &&
                    claim.isSelected === true ? (
                      <li>
                        <i className="fa-solid fa-chevron-left"></i>{" "}
                        <Link
                          style={{ color: "#40485b" }}
                          to="/editor/notifications">
                          <span
                            style={{
                              color: colors[Math.floor(Math.random() * 5) + 1],
                            }}>
                            {" "}
                            إدارة الأشعارات
                          </span>
                        </Link>
                        <hr />
                      </li>
                    ) : null
                  )
                )}
              </ul>
              {/* <ul className="footer-links">
          <h2>أضافات</h2> 
                    <li >
                      <i className="fa-solid fa-chevron-left"></i>
                      <span onClick={handleShowMain}>حساب رئيسي</span>
                    </li>
                    <li >
                      <i className="fa-solid fa-chevron-left"></i>
                      <span onClick={handleShowSub}>حساب فرعي</span>
                    </li>
          </ul> */}
            </div>
          </div>
        </Fade>
        <Fade direction="left">
          <div className="imges">
            <img src={dash} alt="" />
          </div>
        </Fade>
      </div>
    </div>
  );
};

export default Mainadminpage;
